import { DataTableMeta, DateColumn } from '@otp/ui';
import { TFunction } from 'i18next';

import { UserActivity } from 'src/graphql/generated/graphql';
import { UsernameEmail } from 'src/components/manage-otps/list/table/columns/username-email';

export const getTableConfig = (
  userActivities: Partial<UserActivity>[],
  {
    t,
  }: {
    t: TFunction;
  },
) => [
  {
    name: 'lastName',
    label: t('common.name'),
    options: {
      sort: true,
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = userActivities[column.rowIndex];
        return (
          <UsernameEmail
            user={{
              firstName: rowData.firstName || '',
              lastName: rowData.lastName || '',
            }}
            options={{ nameOnly: true }}
          />
        );
      },
    },
  },
  {
    name: 'mcId',
    label: t('common.eid'),
    options: {
      sort: false,
    },
  },
  {
    name: 'updatedAt',
    label: t('common.created-at'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = userActivities[column.rowIndex];
        return <DateColumn date={rowData.createdAt} />;
      },
      sort: true,
    },
  },
  {
    name: 'note',
    label: t('common.activity'),
  },
];
